import { privateApi } from 'services/Api/ApiService';
import { TalentsLastEditor } from './types';

const fetchLeadsLastEditors = (businessAccountId: string): Promise<TalentsLastEditor[]> =>
    privateApi.get<TalentsLastEditor[]>(`business-accounts/${businessAccountId}/leads/last-editors`);

export const LeadsLastEditorsGateway = {
    fetchLeadsLastEditors,
};
